import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "../../../api/axios";
import { PMDialog } from "../PMDialog";
import { ResourceLoading } from "../ResourceLoading";
import { ResourceEmpty } from "../ResourceEmpty";

export const CategorySelector = (props) => {
  const { t } = useTranslation();
  const { onChange, setFieldValue, label, selected } = props;
  const name = props.name || "product_category_id";
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(selected || null);
  const [query, setQuery] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCurrent(selected || null);
  }, [selected]);

  useEffect(() => {
    if (!open) return undefined;
    let cancelled = false;
    setLoading(true);
    axios({
      method: "get",
      url: "/products/categories/",
      params: {
        query: query || "",
        page: 1,
        per_page: 50,
        sortBy: "title",
        sort: "asc",
        fields: "id,title,displayTitle,parent",
      },
    })
      .then((response) => {
        if (cancelled) return;
        const rows = response.data?.data || [];
        setItems(Array.isArray(rows) ? rows : []);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, query]);

  const title =
    current?.displayTitle || current?.title || current?.primary || "";

  const pick = (category) => {
    setCurrent(category || null);
    if (onChange) onChange(category || null);
    if (setFieldValue) setFieldValue(name, category?.id || null);
    setOpen(false);
  };

  return (
    <>
      <div
        className="cursor-pointer"
        onClick={() => setOpen(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setOpen(true);
          }
        }}
        role="button"
        tabIndex={0}
      >
        <label className="block text-sm font-medium text-gray-700">
          {label || t("service.agreements.discount_lines.category")}
        </label>
        {current?.id ? (
          <div className="flex items-center justify-between border-b-4 border-indigo-300 p-2 font-bold">
            <span>{title}</span>
          </div>
        ) : (
          <div className="text-gray-400">
            Velg {label || t("service.agreements.discount_lines.category")}
          </div>
        )}
      </div>

      <PMDialog
        open={open}
        onClose={() => setOpen(false)}
        title={label || t("service.agreements.discount_lines.category")}
        size="lg"
        zIndex={4000}
      >
        <div className="space-y-3 text-left">
          <input
            type="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={t("Search") || "Søk …"}
            className="w-full rounded-xl border border-slate-300 px-3 py-2 text-sm focus:border-[#1463C7] focus:outline-none focus:ring-2 focus:ring-[#1463C7]/20"
          />
          <div className="max-h-[min(24rem,60vh)] overflow-y-auto rounded-xl border border-slate-200">
            {loading ? (
              <ResourceLoading />
            ) : items.length === 0 ? (
              <div className="p-6">
                <ResourceEmpty />
              </div>
            ) : (
              <ul>
                {items.map((row) => (
                  <li key={row.id}>
                    <button
                      type="button"
                      onClick={() => pick(row)}
                      className="w-full border-b border-slate-100 px-4 py-3 text-left text-sm hover:bg-[#EAF3FD]"
                    >
                      <span className="font-semibold text-slate-900">
                        {row.displayTitle || row.title}
                      </span>
                      {row.parent?.title ? (
                        <span className="mt-0.5 block text-xs text-slate-500">
                          {row.parent.title}
                        </span>
                      ) : null}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </PMDialog>
    </>
  );
};
